"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteInvoice = deleteInvoice;
exports.getInvoiceList = getInvoiceList;
exports.saveInvoiceList = saveInvoiceList;
exports.updateInvoiceList = updateInvoiceList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 推荐购分页

function getInvoiceList(data) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceCompany/page',
    method: 'post',
    params: data
  });
}
function saveInvoiceList(data) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceCompany/save',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
function updateInvoiceList(data) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceCompany/update',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
function deleteInvoice(id) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceCompany/delete',
    method: 'post',
    params: {
      id: id
    }
  });
}